/* eslint-disable */
import Long from 'long';
import * as _m0 from 'protobufjs/minimal';

export const protobufPackage = 'od_protos.web.data.sell_direct';

/**
 * Next ID: 8
 * SoT for key events throughout a customer's sell direct experience
 */
export enum SellDirectEventType {
  UNKNOWN = 0,
  /** PRELIM_OFFER_SENT - The customer's preliminary offer has been sent. Correlates with the "sent" offer state. */
  PRELIM_OFFER_SENT = 1,
  /** FINAL_OFFER_SENT - The customer's final offer has been sent. Occurs after underwriting has been completed. */
  FINAL_OFFER_SENT = 2,
  /** FINAL_OFFER_VIEWED - The customer has viewed their final offer. Correlates with the "accepted" offer state. */
  FINAL_OFFER_VIEWED = 3,
  /** OFFER_CONTINGENCY_RELEASED - The customer has signed the purchase agreement. Correlates with the "contingency_released" offer state. */
  OFFER_CONTINGENCY_RELEASED = 4,
  /** OFFER_CLOSED - The customer has completed the transaction with Opendoor. Correlates with the "closed" offer state. */
  OFFER_CLOSED = 5,
  /** OFFER_EXPIRED - The customer did not sign the purchase agreement in the allotted time. Correlates with the "expired" offer state. */
  OFFER_EXPIRED = 6,
  /** OFFER_WITHDRAWN - The transaction has been canceled by Opendoor or the customer after the contract has been signed. Correlates with the "withdrawn" offer state. */
  OFFER_WITHDRAWN = 7,
  UNRECOGNIZED = -1,
}

export function sellDirectEventTypeFromJSON(object: any): SellDirectEventType {
  switch (object) {
    case 0:
    case 'UNKNOWN':
      return SellDirectEventType.UNKNOWN;
    case 1:
    case 'PRELIM_OFFER_SENT':
      return SellDirectEventType.PRELIM_OFFER_SENT;
    case 2:
    case 'FINAL_OFFER_SENT':
      return SellDirectEventType.FINAL_OFFER_SENT;
    case 3:
    case 'FINAL_OFFER_VIEWED':
      return SellDirectEventType.FINAL_OFFER_VIEWED;
    case 4:
    case 'OFFER_CONTINGENCY_RELEASED':
      return SellDirectEventType.OFFER_CONTINGENCY_RELEASED;
    case 5:
    case 'OFFER_CLOSED':
      return SellDirectEventType.OFFER_CLOSED;
    case 6:
    case 'OFFER_EXPIRED':
      return SellDirectEventType.OFFER_EXPIRED;
    case 7:
    case 'OFFER_WITHDRAWN':
      return SellDirectEventType.OFFER_WITHDRAWN;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return SellDirectEventType.UNRECOGNIZED;
  }
}

export function sellDirectEventTypeToJSON(object: SellDirectEventType): string {
  switch (object) {
    case SellDirectEventType.UNKNOWN:
      return 'UNKNOWN';
    case SellDirectEventType.PRELIM_OFFER_SENT:
      return 'PRELIM_OFFER_SENT';
    case SellDirectEventType.FINAL_OFFER_SENT:
      return 'FINAL_OFFER_SENT';
    case SellDirectEventType.FINAL_OFFER_VIEWED:
      return 'FINAL_OFFER_VIEWED';
    case SellDirectEventType.OFFER_CONTINGENCY_RELEASED:
      return 'OFFER_CONTINGENCY_RELEASED';
    case SellDirectEventType.OFFER_CLOSED:
      return 'OFFER_CLOSED';
    case SellDirectEventType.OFFER_EXPIRED:
      return 'OFFER_EXPIRED';
    case SellDirectEventType.OFFER_WITHDRAWN:
      return 'OFFER_WITHDRAWN';
    default:
      return 'UNKNOWN';
  }
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}
